import React from 'react'

import Filters from './Filters'
import CalculateOperation from './CalculateOperation'
import ReplaceOperation from './ReplaceOperation'
import TimeDifferenceOperation from './TimeDifferenceOperation'

const ManageOperation = ({
  type,
  chosenAttributes,
  filterData,
  setFilterData
}) => {
  return type ? (
    <>
      {type === 'FILTER' && (
        <Filters
          chosenAttributes={chosenAttributes}
          filterData={filterData}
          setFilterData={setFilterData}
        />
      )}
      {type === 'CALCULATE' && (
        <CalculateOperation
          chosenAttributes={chosenAttributes}
          filterData={filterData}
          setFilterData={setFilterData}
          type={type}
        />
      )}
      {type === 'REPLACE' && (
        <ReplaceOperation
          chosenAttributes={chosenAttributes}
          filterData={filterData}
          setFilterData={setFilterData}
          type={type}
        />
      )}
      {type === 'TIME_DIFFERENCE' && (
        <TimeDifferenceOperation
          chosenAttributes={chosenAttributes}
          filterData={filterData}
          setFilterData={setFilterData}
          type={type}
        />
      )}
    </>
  ) : null
}

export default ManageOperation
